import React from 'react';

export default function TransformButton({ setTransformMode, label, action }) {
  return (
    <div className="flex flex-col justify-center items-center">
      <button
        className="p-3 flex flex-col items-center bg-dk-beige rounded-lg transition duration-300 hover:bg-white"
        onClick={() => setTransformMode(action)}
      >
        <img
          src={`images/${label}.png`}
          className="h-[24px] w-[24px]"
          alt="rotate"
        />
      </button>
      <span className="text-sm uppercase">{label}</span>
    </div>
  );
}
